import clsx from 'clsx';
import { ImageSign } from 'types/studio/studio';
import { Typography, Space } from '@ag1/ui';
import { StudioHotspotImageV2 } from 'shared/studio/StudioHotspotImage';

import styles from './EduArticleImage.module.scss';

export const EduArticleImage = ({ image, imageDirection, sign }: ImageSign) => (
  <Space className={styles.space} top={{ xxs: 32, s: 48 }} bottom={{ xxs: 32, s: 48 }}>
    <div
      className={clsx(
        styles.wrapper,
        imageDirection === 'vertical' ? styles.vertical : styles.horizontal
      )}>
      <StudioHotspotImageV2
        className={clsx(
          styles.image,
          imageDirection === 'vertical' ? styles.vertical : styles.horizontal
        )}
        image={image}
      />
      {sign && (
        <Typography className={styles.sign} variant="caption" size="1" noPadding>
          {sign}
        </Typography>
      )}
    </div>
  </Space>
);
